import{REQUEST_PRODUCT}from"../constants";/**
 * Creates the dispatched REQUEST_PRODUCT action object.
 * @param {string} productId The ID of the product to request.
 * @param {boolean} forceFetch flag
 * @return {Object} The REQUEST_PRODUCT action.
 */var requestProduct=function requestProduct(productId){var forceFetch=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;return{type:REQUEST_PRODUCT,productId:productId,forceFetch:forceFetch};};export default requestProduct;